import React, { Component } from "react";
import axios from 'axios';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../styles/common.css";
import "../../styles/videos.css";
import Loader1 from "../loader/loader";
import Grid from "@material-ui/core/Grid";
import {Button, Modal} from 'react-bootstrap';
import playstore from '../../assets/google-play-store-10.jpg';
import appstore from '../../assets/app-store-icon.png';
import logo from '../../assets/logo.png';
// Put this at the top of karaoke.js, before your class
function safeJSONParse(data) {
  try {
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.warn("Invalid JSON in sessionStorage:", data);
    return [];
  }
}

class Karaoke extends Component {
  constructor(props) {
    super(props);
    this.state = {
      karaoke1: [],
      other: [],
      isLoading: false,
      isShow: false,
      show: false
    };
    this.unMounted = false;
  }
  

  fetchCategories = () => {
    this.setState({ karaoke1: [], other: [], isLoading: true });
  
    axios.get("https://app.momoappnepal.com/api/net-tv/karaokes")
      .then(res => {
        if (!this.unMounted) {
          const data = res.data; 
          const karaoke1 = data.categories || []; 
          const other = []; 
  
          this.setState({
            karaoke1,
            other,
            isLoading: false
          });
  
          // store in sessionStorage for caching
          sessionStorage.setItem('karaoke1', JSON.stringify(karaoke1));
          sessionStorage.setItem('other', JSON.stringify(other));
  
          console.log("karokes in homepage", karaoke1);
        }
      })
      .catch(error => {
        console.error("Error fetching categories:", error);
        this.setState({ isLoading: false });
      });
  }
  

  componentDidMount = () => {
    const karaokeData = safeJSONParse(sessionStorage.getItem('karaoke1'));
    const otherData = safeJSONParse(sessionStorage.getItem('other'));
  
    if (karaokeData.length || otherData.length) {
      this.setState({
        karaoke1: karaokeData,
        other: otherData,
        isLoading: false
      });
    } else {
      this.fetchCategories();
    }
  }
  

  componentDidUpdate(prevProps, prevState) {
    if (prevState.karaoke1 !== this.state.karaoke1) {
      sessionStorage.setItem('karaoke1', JSON.stringify(this.state.karaoke1));
    }
    if (prevState.other !== this.state.other) {
      sessionStorage.setItem('other', JSON.stringify(this.state.other));
    }
  }

  componentWillUnmount = () => {
    this.unMounted = true;
  }

  handleClick = () => this.setState({ isShow: true });
  handleShow = () => this.setState({ show: true });
  handleClose = () => this.setState({ show: false });

  render() {
    const { karaoke1, other, isLoading } = this.state;
  
    const getKaraoke = karaoke1.map(d => (
      <div className="textChange" style={{width: '100%'}} key={d.id}>
        <h3 className="text-uppercase">{d.name}</h3>
        <div className="row">
          {d.karaokes.map(a => (
            <div className="col-lg-2 col-md-2 col-sm-3 col-4" key={a.id}>
              <div className="geetInfo1 link">
                <img onClick={this.handleShow} src={a.logo} height="200px" />
                <div className="truncate cardContent" style={{textAlign:'center'}}>
                  <p>{a.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <hr/>
      </div>
    ));
  
    const getKaraoke2 = other.map(a => (
      <div className="textChange" style={{width: '100%'}} key={a.id}>
        <h3 className="text-uppercase">{a.name}</h3>
        <div className="row">
          {a.karaokes.map(d => (
            <div className="col-lg-2 col-md-2 col-sm-3 col-4" key={a.id}>
              <div className="geetInfo1 link">
                <img onClick={this.handleShow} src={d.logo} height="200px" />
                <div className="truncate cardContent" style={{textAlign:'center'}}>
                  <p>{a.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <hr/>
      </div>
    ));
  
    if (isLoading) return <Loader1 />;
  
    return (
      <React.Fragment>
        <Grid container spacing={4} className="homepageGridContainer">
          {getKaraoke}
        </Grid>
        <Grid container spacing={4} className="homepageGridContainer">
          {getKaraoke2}
        </Grid>
  
        {/* <Modal show={show} onHide={this.handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Get MOMO- More Music More Movies App</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            ...modal content...
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal> */}
                <Modal
         show={this.state.show} onHide={()=>this.handleClose()}
         centered
         
        >
        <Modal.Header closeButton >
        <Modal.Title>Get MOMO- More Music More Movies App</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Currently, playing feature is only available in apps. Please, download app from PLAYSTORE, APPSTORE</p>
        <div className = "row">
        <div className="col-4">
        </div>
        <div className="col-4">
        <div className = "row">
        <div className="col-6">
        <a href="https://play.google.com/store/apps/details?id=com.newitventure.movienmasti&hl=en" target="_blank">
        <img src = {playstore} /> 
        </a>
        </div>
        <div className="col-6">
        <img src = {appstore}/>
        </div>
        </div>
        </div>
        <div className="col-4">
        </div>
        </div>
        <p style={{textAlign:'center', marginBottom:'0px'}}>OR</p>
        <p style={{textAlign:'center'}}>Scan QR Code</p>
        <div className="row">
        <div className="col-4"></div>
        <div className="col-4">
        <div className="row">
        <div className="col-2"><img className="modalqr" src = {logo} style={{height:'100px', width:'140px'}}/>
        </div>
        <div className="col-2">
        </div>
        <div className="col-2">
        </div>
        </div>
        </div>
        <div className="col-4"></div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={()=>this.handleClose()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
      </React.Fragment>
    );
  }
}
  export default Karaoke;  


